export default __webpack_public_path__ + "static/media/ic_nicaragua.ba71e80a.svg";